/*export const data = [
	{
		id:1,
		img:'assets/img/about.jpg',
		about:'An independent and self-motivated student on the quest of anoppourtinity for an entry-level position in the webdevelopment that can acquiant me with knowledge and experience',
		birthday:'17 Feb 2004',
		website: '',
		phone: '+918080301532',
		city: 'pune',
	}
]*/

export const skills_data = [
	{
		id:1,
		icon:'fa-brands fa-react',
		name:'React',
		color:'#e6661c',
	},
	{
		id:2,
		icon:'fa-brands fa-html5',
		name:'HTML',
		color:'#89d645',
	},
	{
		id:3,
		icon:'fa-brands fa-css3',
		name:'CSS',
		color:'#457ad6',
	},
	{
		id:4,
		icon:'fa-brands fa-js',
		name:'JS',
		color:'#dc66de',
	},
	{
		id:5,
		icon:'fa-brands fa-php',
		name:'PHP',
		color:'#edf24e',
	},
	{
		id:5,
		icon:'fa-brands fa-flask',
		name:'Flask',
		color:'#eb63b2',
	},
	{
		id:6,
		icon:'fa-brands fa-database',
		name:'SQL',
		color:'#eb6363',
	},
	{
		id:7,
		icon:'fa-brands fa-c',
		name:'C',
		color:'#63e4eb',
	},
	{
		id:8,
		icon:'fa-brands fa-c++',
		name:'C++',
		color:'#eb63a2',
	},
	{
		id:9,
		icon:'fa-brands fa-java',
		name:'Java',
		color:'#eb6763',
	},
	{
		id:10,
		icon:'fa-brands fa-python',
		name:'Python',
		color:'#b9eb63',
	},
	{
		id:11,
		icon:'fa-brands fa-php',
		name:'.Net',
		color:'#6389eb',
	},
	{
		id:12,
		icon:'fa-brands fa-bootstrap',
		name:'Bootstrap',
		color:'#a85032',
	},
	{
		id:13,
		icon:'fa-brands fa-github',
		name:'Github',
		color:'#a8327b',
	},
	{
		id:14,
		icon:'fa-brands fa-hive',
		name:'Blockchain',
		color:'#457ad6',
	},
	{
		id:15,
		icon:'fa-brands fa-node',
		name:'Node',
		color:'#997ad6',
	},
	{
		id:15,
		icon:'fa-brands fa-envira',
		name:'Mongodb',
		color:'#eb6363',
	},
	{
		id:16,
		icon:'fa-brands fa-ethereum',
		name:'Solidity',
		color:'#fb63a2',
	},
	
	
]